import { styled } from "@mui/material";
import { Sidebar } from "../molecules";
import { SUBMENU } from "../../constants/submenu";
import { BasicsSubmenu } from "./BasicsSubmenu";
import { COLORS } from "../../constants/colors";

const SubmenuContainer = styled(Sidebar)`
  padding-top: 1em;
  left: 56px;
  top: 0;
  width: 200px;
  box-shadow: 2px 0px 0px ${COLORS.BORDER};
`;

interface SubmenuProps {
  selected: string;
}

const Submenu = ({ selected }: SubmenuProps) => {
  const getSubmenu = () => {
    switch (selected) {
      case SUBMENU.BASICS:
      default:
        return <BasicsSubmenu />;
    }
  };

  return <SubmenuContainer>{getSubmenu()}</SubmenuContainer>;
};

export { Submenu };
